module.exports = __webpack_public_path__ + "static/media/28DGC11.ebb5a160.jpg";